  // import { unparse } from 'papaparse';
  // import { saveAs } from 'file-saver';

  // export const downloadCSV = (tableHeader, data, filename) => {
  //   const tableHeaderKey = Object.keys(tableHeader[0]).map((header, index) => (header))
  //   const tableHeaderValue = Object.values(tableHeader[0]).map((value, index) => (value))
  //   const mappedData = data.map(row => {
  //     const newRow = {};
  //     Object.keys(row).forEach(key => {
  //       newRow[tableHeaderValue[key] || key] = row[key];
  //     });
  //     return newRow;
  //   });


  //   const csv = unparse(mappedData, { header: true });
  //   const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  //   saveAs(blob, `${filename}.csv`);
  // };


  import { unparse } from 'papaparse';
import { saveAs } from 'file-saver';
import { capitalizeFirstLetter } from './common';
import { ROLES } from './constant';

const getCourseName = (row) => {
  return row?.postGraduationCourseName || row?.graduationCourseName || row?.diplomaCourseName || "";
};
const getBranchName = (row) => {
  return row?.postGraduationBranchName || row?.graduationBranchName || row?.diplomaBranchName|| "";
};

export const downloadCSV = (tableHeader, data, filename) => {
  if (!Array.isArray(tableHeader) || tableHeader.length === 0) {
    console.error("Invalid tableHeader format");
    return;
  }

  const tableHeaderKeys = Object.keys(tableHeader[0]); // Extract API field names
  const tableHeaderValues = Object.values(tableHeader[0]); // Extract column names

  const mappedData = data.map(row => {
    const newRow = {};
    tableHeaderKeys.forEach(col => {
      if (filename === "payment") {
        if (col === 'userType' && row?.userDetails?.[col] === ROLES.OFF_STUDENT) {
          newRow[tableHeader[0][col]] = 'Off Student';
        } else if (col === 'userType' && row?.userDetails?.[col] === ROLES.ON_STUDENT) {
          newRow[tableHeader[0][col]] = 'On Student';
        } else if (col === 'name' && (row?.userDetails?.userType === ROLES.OFF_STUDENT || row?.userDetails?.userType === ROLES.ON_STUDENT)) {
          newRow[tableHeader[0][col]] = `${capitalizeFirstLetter(row?.userDetails?.firstName)}`;
        } else {
          newRow[tableHeader[0][col]] = row[col] || row?.userDetails?.[col] || '';
        }
      } else if (filename === "student") {
        if (col === 'name') {
          newRow[tableHeader[0][col]] = `${capitalizeFirstLetter(row?.firstName)} ${capitalizeFirstLetter(row?.lastName)}`;
        } else if (col === 'course') {
          newRow[tableHeader[0][col]]  = capitalizeFirstLetter(getCourseName(row));
        } else if (col === 'branch') {
          newRow[tableHeader[0][col]]  = capitalizeFirstLetter(getBranchName(row));
        } else {
          newRow[tableHeader[0][col]] = row[col] || row?.userDetails?.[col] || '';
        }
      } else {
        newRow[tableHeader[0][col]] = row[col] || row?.userDetails?.[col] || '';
      }
    });
    return newRow;
  });

  const csv = unparse(mappedData, { header: true });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, `${filename}.csv`);
};
